import { createBrowserRouter } from "react-router";
import { Layout } from "./components/Layout";
import { LegalLayout } from "./components/LegalLayout";
import { AdminLayout } from "./admin/AdminLayout";
import { AdminLogin } from "./admin/AdminLogin";
import { AdminDashboard } from "./admin/pages/AdminDashboard";
import { AdminEnquiries } from "./admin/pages/AdminEnquiries";
import { AdminBlog } from "./admin/pages/AdminBlog";
import { AdminBlogEditor } from "./admin/pages/AdminBlogEditor";
import { AdminProducts } from "./admin/pages/AdminProducts";
import { AdminProductEditor } from "./admin/pages/AdminProductEditor";
import { AdminServices } from "./admin/pages/AdminServices";
import { AdminServiceEditor } from "./admin/pages/AdminServiceEditor";
import { AdminProjects } from "./admin/pages/AdminProjects";
import { AdminProjectEditor } from "./admin/pages/AdminProjectEditor";
import { AdminProfile } from "./admin/pages/AdminProfile";
import { HomePage } from "./components/HomePage";
import { ServicesPage } from "./components/ServicesPage";
import { ServiceDetailPage } from "./components/ServiceDetailPage";
import { AboutPage } from "./components/AboutPage";
import { ProductsPage } from "./components/ProductsPage";
import { ProjectsPage } from "./components/ProjectsPage";
import { BlogPage } from "./components/BlogPage";
import { BlogDetailPage } from "./components/BlogDetailPage";
import { ContactPage } from "./components/ContactPage";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { TermsConditions } from "./components/TermsConditions";
import { Sitemap } from "./components/Sitemap";
import { NotFound } from "./components/NotFound";

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Layout,
    children: [
      { index: true, Component: HomePage },
      { path: "services", Component: ServicesPage },
      { path: "services/:serviceId", Component: ServiceDetailPage },
      { path: "about", Component: AboutPage },
      { path: "products", Component: ProductsPage },
      { path: "projects", Component: ProjectsPage },
      { path: "blog", Component: BlogPage },
      { path: "blog/:slug", Component: BlogDetailPage },
      { path: "contact", Component: ContactPage },
      { path: "*", Component: NotFound },
    ],
  },
  {
    path: "/",
    Component: LegalLayout,
    children: [
      { path: "privacy-policy", Component: PrivacyPolicy },
      { path: "terms", Component: TermsConditions },
      { path: "sitemap", Component: Sitemap },
    ],
  },
  // ── Admin (no public layout) ──
  { path: "/admin/login", Component: AdminLogin },
  {
    path: "/admin",
    Component: AdminLayout,
    children: [
      { index: true, Component: AdminDashboard },
      { path: "profile", Component: AdminProfile },
      { path: "enquiries", Component: AdminEnquiries },
      { path: "blog", Component: AdminBlog },
      { path: "blog/new", Component: AdminBlogEditor },
      { path: "blog/:id", Component: AdminBlogEditor },
      { path: "products", Component: AdminProducts },
      { path: "products/new", Component: AdminProductEditor },
      { path: "products/:id", Component: AdminProductEditor },
      { path: "services", Component: AdminServices },
      { path: "services/new", Component: AdminServiceEditor },
      { path: "services/:id", Component: AdminServiceEditor },
      { path: "projects", Component: AdminProjects },
      { path: "projects/new", Component: AdminProjectEditor },
      { path: "projects/:id", Component: AdminProjectEditor },
      { path: "profile", Component: AdminProfile },
    ],
  },
]);